import { render, staticRenderFns } from "./turingReport.vue?vue&type=template&id=42c8c0d7&scoped=true"
import script from "./turingReport.vue?vue&type=script&lang=js"
export * from "./turingReport.vue?vue&type=script&lang=js"
import style0 from "./turingReport.vue?vue&type=style&index=0&id=42c8c0d7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c8c0d7",
  null
  
)

export default component.exports